import { render, staticRenderFns } from "./abnormalRecord.vue?vue&type=template&id=5aaec956&scoped=true&"
import script from "./abnormalRecord.vue?vue&type=script&lang=js&"
export * from "./abnormalRecord.vue?vue&type=script&lang=js&"
import style0 from "./abnormalRecord.vue?vue&type=style&index=0&id=5aaec956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaec956",
  null
  
)

export default component.exports